import { MenuTypes } from '@/api';
import { StorageFilters } from '@/store/storage/types';

export const INITIAL_FILTERS: StorageFilters = {
  phrase: '',
  menu: MenuTypes.ALL,
  cases: [],
  date: [undefined, undefined],
};
